module.exports = __webpack_public_path__ + "static/media/summerIcon.e1008583.png";